import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
const ethMultiplier = 1000000000000000000;
@observer(["CustomWagerStore"])
class StepOne extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentValue: 50000000000000000,
            currentOdds: 100,
        };
        this.handleIncrement = this.handleIncrement.bind(this);
        this.handleDecrement = this.handleDecrement.bind(this);
        this.handleOddsIncrement = this.handleOddsIncrement.bind(this);
        this.handleOddsDecrement = this.handleOddsDecrement.bind(this);
        this.handleSetValue = this.handleSetValue.bind(this);
        this.handleSetOdds = this.handleSetOdds.bind(this);
    }

    componentWillMount() {
        const { CustomWagerStore } = this.props;

        CustomWagerStore.setValue(this.state.currentValue);
        CustomWagerStore.setOdds(this.state.currentOdds);
    }

    handleIncrement() {
        const { CustomWagerStore } = this.props;

        this.setState({ currentValue: (this.state.currentValue + 50000000000000000) });
        console.log(this.state.currentValue);
        CustomWagerStore.setValue(this.state.currentValue);
    }

    handleDecrement() {
        const { CustomWagerStore } = this.props;



        if (this.state.currentValue >= 100000000000000000) {
            this.setState({ currentValue: (this.state.currentValue - 50000000000000000) });
            console.log(this.state.currentValue);
            CustomWagerStore.setValue(this.state.currentValue);
        }
    }

    handleOddsIncrement() {
        const { CustomWagerStore } = this.props;

        this.setState({ currentOdds: (this.state.currentOdds + 25) });
        console.log(this.state.currentOdds);
        CustomWagerStore.setOdds(this.state.currentOdds);
    }

    handleOddsDecrement() {
        const { CustomWagerStore } = this.props;

        if (this.state.currentOdds >= 49) {
            this.setState({ currentOdds: (this.state.currentOdds - 25) });
            console.log(this.state.currentOdds);
            CustomWagerStore.setOdds(this.state.currentOdds);
        }
    }

    handleSetValue(e) {
        const { CustomWagerStore } = this.props;

        this.setState({ currentValue: (parseFloat(e.target.value) * ethMultiplier).toFixed(4) });
        CustomWagerStore.setValue(parseFloat(e.target.value));
    }

    handleSetOdds(e) {
        const { CustomWagerStore } = this.props;

        this.setState({ currentOdds: parseFloat(e.target.value * 100) });
        CustomWagerStore.setOdds(parseFloat(e.target.value * 100));
    }


    render() {

        let potentialWinValue = (this.state.currentOdds > 99 ?
            (this.state.currentValue / ethMultiplier).toFixed(4) / (this.state.currentOdds / 100)
            :
            (this.state.currentValue / ethMultiplier).toFixed(4) * Math.floor(100 / this.state.currentOdds)

        );

        return (
            <div className="step-one">
                <h1>Select Bet Odds & Value</h1>
                <div className="custom-bets-modal-step-one-grid">
                    <div className="custom-bets-modal-step-one-grid-bet-odds">
                        <div className="custom-bets-modal-step-one-bet-amount-odds-title">Bet Value</div>
                        <div className="ctrl">
                            <div onClick={this.handleIncrement} className="ctrl__button ctrl__button--decrement">
                            </div>
                            <div className="ctrl__counter">
                                <input className="ctrl__counter-input" style={{ width: '143px' }} onChange={this.handleSetValue} maxLength={10} minLength={0} type="text" value={(this.state.currentValue / ethMultiplier).toFixed(4)} /><span style={{ color: "#1f8ffb" }}> ETH</span>
                            </div>
                            <div onClick={this.handleDecrement} className="ctrl__button ctrl__button--increment">
                            </div>
                        </div>
                    </div>
                    <div className="custom-bets-modal-step-one-grid-bet-value">
                        <div className="custom-bets-modal-step-one-bet-amount-odds-title">Bet Odds</div>
                        <div className="ctrl">
                            <div onClick={this.handleOddsIncrement} className="ctrl__button ctrl__button--decrement">
                            </div>
                            <div className="ctrl__counter">
                                <input className="ctrl__counter-input" onChange={this.handleSetOdds} maxLength={10} minLength={0} type="text" value={this.state.currentOdds / 100} /><span style={{ color: "#1f8ffb" }}> : 1</span>
                            </div>
                            <div onClick={this.handleOddsDecrement} className="ctrl__button ctrl__button--increment">
                            </div>
                        </div>
                    </div>
                </div>
                <p style={{ textAlign: 'center' }}>Potential Win: <span style={{ color: "#1f8ffb" }}>{potentialWinValue.toFixed(4)} ETH</span></p>
            </div>
        );
    }
}

export default StepOne;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/customBetSteps/StepOne.js